import React from 'react';
import {useAtomValue} from 'jotai';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {isAuthorizedAtom} from 'features/auth/model/authAtom';
import {TokenManager} from 'features/auth/ui/TokenManager';

export function RequireAuth(): React.ReactElement {
	const isAuthorized = useAtomValue(isAuthorizedAtom);
	const location = useLocation();

	if (!isAuthorized) {
		return <Navigate to="/auth/login" replace state={{from: location}} />;
	}

	return (
		<TokenManager>
			<Outlet />
		</TokenManager>
	);
}

